import ClientModule from "@gqlapp/module-client-react";
export default new ClientModule({});
